import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import PlotChart from './PlotChart';
import { processSnapPlot } from './processSnapPlot';
const yLogBase = 2;
function Spectrum1DHistogram({ color = 'red', data, }) {
    const processedData = useMemo(() => {
        return processSnapPlot('1D', data, yLogBase);
    }, [data]);
    return (_jsxs("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
        }, children: [_jsx("div", { style: { display: 'block' }, children: _jsx(PlotChart, { data: processedData, sign: "positive", color: color, yLogBase: yLogBase }) }), _jsx("div", { style: { display: 'block', width: 180, height: 180 }, children: _jsx(PlotChart, { data: processedData, sign: "negative", color: color, yLogBase: yLogBase, hideHeading: true }) })] }));
}
export default memo(Spectrum1DHistogram);
